export default __webpack_public_path__ + "static/media/t-shirt-border.8d2aa381.svg";